import React from "react";
import cx from "classnames";
import { upperFirst } from "lodash-es";

import { polymorphic } from "../utils";
import styles from "./titlebar.module.scss";
import IconContainer from "../IconContainer/IconContainer";
import ChevronLeft from "../../assets/icons/chevron-left.svg";

export namespace TitleBar {
  export type Props = {
    className?: string;
    as?: "div" | "th";
    size?: "small" | "medium";
    parent?: (event: React.MouseEvent) => void;
  };
}

export const TitleBar = polymorphic("div")<TitleBar.Props>(
  ({
    as: Component,
    children,
    size = "medium",
    className,
    parent,
    ...props
  }) => {
    const classList = cx(
      className,
      styles.titlebar,
      styles[`titlebar${upperFirst(size)}` as keyof typeof styles]
    );

    return (
      <Component {...props} className={classList}>
        <div className={styles.titlebarContainer}>
          {parent && (
            <IconContainer
              onClick={parent}
              title="Go Back"
              className={styles.titlebarContainerParentIndicator}
              icon={ChevronLeft}
              size={6}
            />
          )}
          <div className={styles.titlebarContainerContent}>{children}</div>
        </div>
      </Component>
    );
  }
);
